import { endPointPrivate } from './config'
import axios from 'axios'

export default {
  listar: () => {
    return axios.get(endPointPrivate + 'v1/pedido')
  },
  listarSelect: () => {
    return axios.get(endPointPrivate + 'v1/pedidoStatus')
  },
  listarPedidos: (parametros) => {
    return axios.get(endPointPrivate + 'v1/pedido?termo=' + parametros.termo + '&codStatus=' + parametros.codStatus + '&emissaoDe=' + parametros.emissaoDe + '&emissaoAte=' + parametros.emissaoAte)
  },
  obterPedido: (param) => {
    return axios.get(endPointPrivate + 'v1/pedido/' + param.idPedido + '/' + param.isErp)
  },
  selecionar: () => {
    return axios.get(endPointPrivate + 'v1/dadosTabelasPedido')
  },
  inserirPedido: (pedido) => {
    return axios.post(endPointPrivate + 'v1/pedido', pedido)
  },
  inserirPedidoItem: (pedidoItem) => {
    return axios.post(endPointPrivate + 'v1/pedidoItem', pedidoItem)
  },
  removerItem: (param) => {
    return axios.delete(endPointPrivate + 'v1/pedidoItem/' + param.idPedido + '/' + param.idPedidoItem, param)
  },
  calcularTributos: (item) => {
    return axios.post(endPointPrivate + 'v1/calculaTributacaoPedidoItem', item)
  },
  aplicarDesconto: (item) => {
    return axios.post(endPointPrivate + 'v1/calculaDescontoPedido', item)
  },
  listarSituacaoPedido: () => {
    return axios.get(endPointPrivate + 'v1/situacaoPedido')
  }
}



// WEBPACK FOOTER //
// ./src/services/tablePedidos.js